// Was schiefging, als Satz an der Stelle, an der man es getan hat (Akte,
// Standardmaterial, Leute und Geräte). Wie fehlerText (laden.tsx) – nur die
// Abweisung wegen der Rolle (403 „keine-berechtigung“) sagt hier, was die
// Seite weiß: wer es stattdessen darf.

import { fehlerText, keineBerechtigung } from "./laden.tsx";

export function meldungAus(fehler: unknown, wegenDerRolle = "Das gehört nicht zu deiner Rolle – frag die Leitung, wenn du es brauchst."): string {
  return keineBerechtigung(fehler) ? wegenDerRolle : fehlerText(fehler);
}
